
import { defineComponent } from 'vue'

import PBoToast from '@invivodf/common/src/application/presenters/PBoToast/PBoToast.vue'
import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'
import { provideToastNotification } from '@invivodf/common/src/application/composables'

export default defineComponent({
  name: 'ZLayoutDefault',
  components: {
    PBoToast,
  },
  setup() {
    provideToastNotification()

    const { logout } = useAuthentication()

    return {
      logout,
    }
  },
  methods: {
    onLogout(): void {
      this.logout()
    },
  },
})
